export default "__VITE_ASSET__DMFnX5VT__"